import { coverageDisplayText, coverageFromCounts } from '@/utils/bias'

// The lean words the topic pages share (2026-11-01, the identity mocks):
// "214 left · 253 center · 259 right · Balanced" and the side colours. The
// bar itself is the shared ui/LeanBar.

export const WINGS = ['left', 'center', 'right']

// The lean colours, as every other mark says them (tailwind.config re-cuts
// blue, zinc and red to the Pano lean palette).
export const WING_BAR = {
  left: 'bg-blue-600',
  center: 'bg-zinc-500',
  right: 'bg-red-600',
}
export const WING_TEXT = {
  left: 'text-blue-600 dark:text-blue-400',
  center: 'text-muted-foreground',
  right: 'text-red-600 dark:text-red-400',
}
export const WING_BORDER = {
  left: 'border-blue-600',
  center: 'border-zinc-500',
  right: 'border-red-600',
}

export const totalOf = (counts) =>
  WINGS.reduce((n, w) => n + (counts?.[w] || 0), 0)

// Pano's verdict on the counts, in its display words ("Balanced", "Leans
// Right"), or the stored label when the row carries one.
export function coverageLabel(counts, stored = null) {
  if (stored) return coverageDisplayText(stored)
  const { text, key } = coverageFromCounts(
    counts?.left || 0,
    counts?.center || 0,
    counts?.right || 0
  )
  return key === 'none' ? null : coverageDisplayText(text)
}

export const countsText = (c) =>
  `${c.left || 0} left · ${c.center || 0} center · ${c.right || 0} right`

export const countsAria = (c) =>
  `Coverage: ${c.left || 0} left, ${c.center || 0} center, ${c.right || 0} right`

// "214 left · 253 center · 259 right · Balanced", the line under a row's
// bar.
export function CountsLine({ counts, label, className = '' }) {
  return (
    <span className={`font-sans text-xs text-muted-foreground ${className}`}>
      {countsText(counts)}
      {label && (
        <>
          {' · '}
          <strong className="font-semibold text-foreground">{label}</strong>
        </>
      )}
    </span>
  )
}

// "Person", "Organization", "Place": the topic's kind as the pages print it.
export function kindLabel(kind) {
  const k = String(kind || '')
  return k ? k.charAt(0).toUpperCase() + k.slice(1) : ''
}
